import { render, staticRenderFns } from "./legal.vue?vue&type=template&id=972273e8&"
import script from "./legal.vue?vue&type=script&lang=ts&"
export * from "./legal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports